import { UserAvatarStyles } from './Styles';

export type IProps = {
  avatar?: string;
};

export const UserAvatar = ({ avatar }: IProps) => {
  return <UserAvatarStyles src={avatar || '/Avatar.png'} />;
};
